import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoModule } from "@ngneat/transloco";
import { SharedModule } from "app/shared/shared.module";
import { WorkflowMyTaskStore } from "./my-task/workflow-my-task.store";
import { WorkflowMyTaskService } from "./my-task/workflow-my-task.service";
import { WorkflowTaskStore } from "./workflow-task.store";
import { WorkflowTaskService } from "./workflow-task.service";
import { MatTableModule } from "@angular/material/table";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatChipsModule } from "@angular/material/chips";
import { MatListModule } from "@angular/material/list";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatStepperModule } from "@angular/material/stepper";
import { XhuntEditorComponent } from "app/shared/components/xhunt-editor";
import { CaseItemComponent } from "app/shared/components/case-item/case-item.component";
import { AggridGroupSelectionComponent } from "app/shared/components/base/ag-grid-group/component/aggrid-group-selection";
import { AgGridModule } from "ag-grid-angular";
import { AgGridGroupStore, AgGridgroupService } from "app/shared/components/base/ag-grid-group";
import { SharedDirectiveModule } from "app/shared/directives/directives.module";
import { MultiFilesUploadModule } from "app/shared/components/upload/multi-files-upload.module";
import { ControlType } from "app/shared/components/x-advanced-filter/x-advanced-filter.enum";
import { XAdvancedFilterControl, XAdvancedGroupControl } from "app/shared/components/x-advanced-filter/x-advanced-filter.model";
import { QuillEditorComponent } from "app/shared/components/quill-editor/quill-editor.component";

export class WORKFLOW_TASK_CONSTANT {
    static BACK_PAGE_LIST_MY_TASK: string = '#manage/my-task';
    static BACK_PAGE_LIST_MY_REQUEST: string = '#manage/my-request';
    static BACK_PAGE_LIST_MY_DRAFT: string = '#manage/my-draft';
    static BACK_PAGE_LIST_MY_WATCH: string = '#manage/my-watch';
    static BACK_PAGE_LIST_MY_APPROVALS: string = '#manage/my-approvals';
    static BACK_PAGE_LIST_ALL_REQUEST: string = '#manage/all-request';
    static BACK_PAGE_LIST_REQUEST_TASK: string = '#manage/request-task';
    static BACK_PAGE_LIST_REQUEST_TRACKING: string = '#manage/request-tracking';
    static NAVIGATE_PAGE_LIST_MY_TASK: string = 'manage/my-task';
    static NAVIGATE_PAGE_LIST_MY_REQUEST: string = 'manage/my-request';
    static NAVIGATE_PAGE_LIST_MY_DRAFT: string = 'manage/my-draft';
    static NAVIGATE_PAGE_LIST_MY_WATCH: string = 'manage/my-watch';
    static NAVIGATE_PAGE_LIST_MY_APPROVALS: string = 'manage/my-approvals';
    static NAVIGATE_PAGE_LIST_ALL_REQUEST: string = 'manage/all-request';
    static NAVIGATE_PAGE_LIST_REQUEST_TASK: string = 'manage/request-task';
    static NAVIGATE_PAGE_LIST_REQUEST_TRACKING: string = 'manage/request-tracking';
    static NAVIGATE_PAGE_APPROVE_MY_TASK: string = 'manage/my-task/approve';
    static NAVIGATE_PAGE_DETAIL_MY_REQUEST: string = 'manage/my-request/detail';
    static NAVIGATE_PAGE_DETAIL_MY_DRAFT: string = 'manage/my-draft/detail';
    static NAVIGATE_PAGE_DETAIL_MY_WATCH: string = 'manage/my-watch/detail';
    static NAVIGATE_PAGE_DETAIL_MY_APPROVALS: string = 'manage/my-approvals/detail';
    static NAVIGATE_PAGE_DETAIL_ALL_REQUEST: string = 'manage/all-request/detail';
    static NAVIGATE_PAGE_APPROVE_REQUEST_TASK: string = 'manage/request-task/approve';
    static NAVIGATE_PAGE_DETAIL_REQUEST_TRACKING: string = 'manage/request-tracking/detail';
    static NAVIGATE_PAGE_DRAFT_REQUEST_TRACKING: string = 'manage/request-tracking/draft';
    static PAGE_ATTRIBUTE_MY_REQUEST: string = 'USER_ATTRIBUTE_MY_REQUEST';
    static PAGE_ATTRIBUTE_MY_DRAFT: string = 'USER_ATTRIBUTE_MY_DRAFT';
    static PAGE_ATTRIBUTE_MY_WATCH: string = 'USER_ATTRIBUTE_MY_WATCH';
    static PAGE_ATTRIBUTE_MY_TASK: string = 'USER_ATTRIBUTE_MY_TASK';
    static PAGE_ATTRIBUTE_MY_APPROVALS: string = 'USER_ATTRIBUTE_MY_APPROVALS';
    static PAGE_ATTRIBUTE_ALL_REQUEST: string = 'USER_ATTRIBUTE_ALL_REQUEST';
    static PAGE_ATTRIBUTE_REQUEST_TASK: string = 'USER_ATTRIBUTE_REQUEST_TASK';
    static PAGE_ATTRIBUTE_REQUEST_TRACKING: string = 'USER_ATTRIBUTE_REQUEST_TRACKING';
    static PAGE_ATTRIBUTE_CANDIDATE_MATCHED: string = 'USER_ATTRIBUTE_CANDIDATE_MATCHED';
    static PAGE_ATTRIBUTE_CANDIDATE_NOT_MATCHED: string = 'USER_ATTRIBUTE_CANDIDATE_NOT_MATCHED';

    static NAVIGATE_PAGE_DETAIL_MY_POST: string = 'manage/job-posting/detail';
    static NAVIGATE_PAGE_DETAIL_MY_POST_LIST: string = 'manage/job-posting';

    static readonly MIN_LENGTH_TEXT_SEARCH = 2;
}

export const ImportTaskModule = [
    SharedModule,
    TranslocoModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatTabsModule,
    MatTableModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatRadioModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatChipsModule,
    MatListModule,
    MatCheckboxModule,
    MatStepperModule,
    XhuntEditorComponent,
    QuillEditorComponent,
    CaseItemComponent,
    AgGridModule,
    AggridGroupSelectionComponent,
    SharedDirectiveModule,
    MultiFilesUploadModule
];

export function ImportTaskProvider() {
    return [WorkflowTaskStore, WorkflowTaskService,
        AgGridgroupService, AgGridGroupStore];
}

export function ImportMyTaskProvider() {
    return [WorkflowMyTaskStore, WorkflowMyTaskService];
}

export const LABEL_ACTION = {
    SUBMIT: {
        color: 'primary',
        icon: 'mat_outline:send'
    },
    APPROVE: {
        color: 'primary',
        icon: 'mat_outline:check'
    },
    REJECT: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    SUGGEST_HRBP: {
        color: 'primary',
        icon: 'mat_outline:arrow_back'
    },
    CANCEL: {
        color: 'warn',
        icon: 'heroicons_outline:ats-trash'
    },
    POST_JOB: {
        color: 'primary',
        icon: 'heroicons_outline:posting'
    },
    UPDATE_QUANTITY: {
        color: 'primary',
        icon: 'heroicons_outline:pencil-alt'
    },
    UPDATE_HANDLED_BY: {
        color: 'primary',
        icon: 'heroicons_outline:pencil-alt'
    },
    UPDATE_SPECIAL_ERP: {
        color: 'primary',
        icon: 'heroicons_outline:pencil-alt'
    },
    SUPPORT_CHANGE_EMPLOYEE_TYPE: {
        color: 'primary',
        icon: 'heroicons_outline:pencil-alt'
    },
    DELAY_NOTE: {
        color: 'primary',
        icon: 'mat_outline:timer_off'
    },
    PENDING_REQUEST: {
        color: 'warn',
        icon: 'mat_outline:lock_clock'
    },
    REOPEN_REQUEST: {
        color: 'primary',
        icon: 'mat_outline:lock_open'
    },
    MATCHING_CANDIDATE: {
        color: 'primary',
        icon: 'mat_outline:repeat'
    },
    IMPORT_DATA: {
        color: 'primary',
        icon: 'mat_outline:repeat'
    },
    DELETE_CANDIDATE: {
        color: 'warn',
        icon: 'heroicons_outline:ats-trash'
    },
    DELETE_CANDIDATE_WHEN_CLOSE: {
        color: 'warn',
        icon: 'heroicons_outline:ats-trash'
    },
    CLOSE_CANDIDATE: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    CLOSE_CANDIDATE_NOT_START: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    SEND_TO_SCREENING: {
        color: 'primary',
        icon: 'mat_outline:person_search'
    },
    FAIL_CANDIDATE: {
        color: 'warn',
        icon: 'mat_outline:unpublished'
    },
    PASS_CANDIDATE: {
        color: 'primary',
        icon: 'heroicons_outline:check-circle'
    },
    FAIL_INTERVIEW: {
        color: 'warn',
        icon: 'mat_outline:unpublished'
    },
    PASS_INTERVIEW: {
        color: 'primary',
        icon: 'heroicons_outline:check-circle'
    },
    CLOSE: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    SEND_TO_CONFIRM: {
        color: 'primary',
        icon: 'mat_outline:supervisor_account'
    },
    SETUP_INTERVIEW: {
        color: 'primary',
        icon: 'mat_outline:supervised_user_circle'
    },
    SEND_TO_INTERVIEW: {
        color: 'primary',
        icon: 'mat_outline:table_view'
    },
    SEND_TO_SUMMARIZE_INTERVIEW: {
        color: 'primary',
        icon: 'mat_outline:table_chart'
    },
    SEND_TO_OFFER: {
        color: 'primary',
        icon: 'mat_outline:local_offer'
    },
    CREATE_OFFER: {
        color: 'primary',
        icon: 'mat_outline:local_offer'
    },
    ACCEPT_OFFER: {
        color: 'primary',
        icon: 'mat_outline:local_offer'
    },
    REJECT_OFFER: {
        color: 'warn',
        icon: 'mat_outline:unpublished'
    },
    RESEND_OFFER: {
        color: 'primary',
        icon: 'heroicons_outline:receipt-refund'
    },
    CANDIDATE_ACCEPT_OFFER: {
        color: 'primary',
        icon: 'heroicons_outline:check-circle'
    },
    ACCEPT_OFFER_CHANGE_EMP_TYPE: {
        color: 'primary',
        icon: 'mat_outline:local_offer'
    },
    KEEP_IN_VIEW: {
        // color: 'primary',
        icon: 'mat_outline:remove_red_eye'
    },
    SAVE_DRAFT: {
        // color: 'primary',
        icon: 'mat_outline:save'
    },
    TRACKING: {
        color: 'primary',
        icon: 'mat_outline:event_note'
    },
    DIRECT_ERP: {
        color: 'primary',
        icon: 'mat_outline:web_asset'
    },
    REMOVE_DIRECT_ERP: {
        color: 'primary',
        icon: 'mat_outline:web_asset_off'
    },
    NEXT_INTERVIEW: {
        color: 'primary',
        icon: 'mat_outline:table_view'
    },
    NEXT_TASK: {
        color: 'primary',
        icon: 'mat_outline:skip_next'
    },
    MORE_INFORMATION: {
        color: 'primary',
        icon: 'mat_outline:more'
    },
    PRINT_INTERVIEWS: {
        color: 'primary',
        icon: 'mat_outline:print'
    },
    SCAN_CANDIDATE: {
        color: 'primary',
        icon: 'mat_outline:document_scanner'
    },
    TRANSFER_CNB: {
        color: 'primary',
        icon: 'mat_outline:directions_transit'
    },
    UPDATE_TRANSFER_CNB: {
        color: 'primary',
        icon: 'mat_outline:directions_transit'
    },
    RESEND_WAITING_CANDIDATE_ACCEPTANCE: {
        color: 'primary',
        icon: 'mat_outline:directions_transit'
    },
    UPDATE_OFFER: {
        color: 'primary',
        icon: 'mat_outline:local_offer'
    },
    CANCEL_CANDIDATE: {
        color: 'warn',
        // icon: 'heroicons_outline:x'
        icon: 'mat_outline:cancel'
    },
    PRINT_OFFER: {
        color: 'primary',
        icon: 'mat_outline:print'
    },
    SEND_EMAIL_TO_INTERVIEWS: {
        color: 'primary',
        icon: 'mat_outline:email'
    },
    SEND_EMAIL_TO_CANDIDATE: {
        color: 'primary',
        icon: 'mat_outline:contact_mail'
    },
    CANCEL_MEETING: {
        color: 'warn',
        icon: 'mat_outline:cancel'
    },
    SEND_EMAIL_OFFER: {
        color: 'primary',
        icon: 'mat_outline:email'
    },
    CLOSE_REQUEST: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    CANCEL_REQUEST: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    CLOSE_INTERVIEW_CONFIRM: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    FAIL_INTERVIEW_CONFIRM: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    REOPEN_CANDIDATE: {
        color: 'primary',
        icon: 'heroicons_outline:receipt-refund'
    },
    REOPEN_CANDIDATE_NOT_START: {
        color: 'primary',
        icon: 'heroicons_outline:receipt-refund'
    },
    ONLINE_CANDIDATE_APPROVE_AI: {
        color: 'primary',
        icon: 'heroicons_outline:badge-check'
    },
    ONLINE_CANDIDATE_APPROVE: {
        color: 'primary',
        icon: 'mat_outline:check'
    },
    ONLINE_CANDIDATE_REJECT: {
        color: 'warn',
        icon: 'heroicons_outline:x-circle'
    },
    RR_SCREENING_ASSESSMENT: {
        color: 'primary',
        icon: 'mat_outline:note_alt'
    },
}

export class ACTION_CODE_RECRUIT_PROCESS {
    static POST_JOB: string = 'POST_JOB';
    static MATCHING_CANDIDATE: string = 'MATCHING_CANDIDATE';
    static IMPORT_DATA: string = 'IMPORT_DATA';
    static UPDATE_QUANTITY: string = 'UPDATE_QUANTITY';
    static UPDATE_HANDLED_BY: string = 'UPDATE_HANDLED_BY';
    static UPDATE_SPECIAL_ERP: string = 'UPDATE_SPECIAL_ERP';
    static SUPPORT_CHANGE_EMPLOYEE_TYPE: string = 'SUPPORT_CHANGE_EMPLOYEE_TYPE';
    static DELAY_NOTE: string = 'DELAY_NOTE';
    static PENDING_REQUEST: string = 'PENDING_REQUEST';
    static REOPEN_REQUEST: string = 'REOPEN_REQUEST';
    static APPROVE: string = 'APPROVE';
    static CANCEL: string = 'CANCEL';
    static REJECT: string = 'REJECT';
    static SUGGEST_HRBP: string = 'SUGGEST_HRBP';
    static CLOSE_REQUEST: string = 'CLOSE_REQUEST';
    static CANCEL_REQUEST: string = 'CANCEL_REQUEST';
}

export class ACTION_CODE_CANDIDATE_PROCESS {
    static SEND_TO_SUMMARIZE_INTERVIEW: string = 'SEND_TO_SUMMARIZE_INTERVIEW';
    static SEND_TO_FAIL_SUMMARIZE_INTERVIEW: string = 'SEND_TO_FAIL_SUMMARIZE_INTERVIEW';
    static SEND_TO_INTERVIEW: string = 'SEND_TO_INTERVIEW';
    static SEND_EMAIL_TO_INTERVIEWS: string = 'SEND_EMAIL_TO_INTERVIEWS';
    static SEND_EMAIL_TO_CANDIDATE: string = 'SEND_EMAIL_TO_CANDIDATE';
    static CANCEL_MEETING: string = 'CANCEL_MEETING';
    static SEND_TO_SCREENING: string = 'SEND_TO_SCREENING';
    static CLOSE_SETUP_CONFIRM: string = 'CLOSE';
    static CLOSE_SETUP_INTERVIEW: string = 'CLOSE';
    static SEND_TO_CONFIRM: string = 'SEND_TO_CONFIRM';
    static PASS_CANDIDATE: string = 'PASS_CANDIDATE';
    static FAIL_CANDIDATE: string = 'FAIL_CANDIDATE';
    static PASS_INTERVIEW: string = 'PASS_INTERVIEW';
    static FAIL_INTERVIEW: string = 'FAIL_INTERVIEW';
    static CLOSE_CANDIDATE_NOT_START: string = 'CLOSE_CANDIDATE_NOT_START';
    static DELETE_CANDIDATE: string = 'DELETE_CANDIDATE';
    static DELETE_CANDIDATE_WHEN_CLOSE: string = 'DELETE_CANDIDATE_WHEN_CLOSE';
    static SEND_TO_OFFER: string = 'SEND_TO_OFFER';
    static CREATE_OFFER: string = 'CREATE_OFFER';
    static ACCEPT_OFFER: string = 'ACCEPT_OFFER';
    static REJECT_OFFER: string = 'REJECT_OFFER';
    static RESEND_OFFER: string = 'RESEND_OFFER';
    static CANDIDATE_ACCEPT_OFFER: string = 'CANDIDATE_ACCEPT_OFFER';
    static ACCEPT_OFFER_CHANGE_EMP_TYPE: string = 'ACCEPT_OFFER_CHANGE_EMP_TYPE';
    static KEEP_IN_VIEW: string = 'KEEP_IN_VIEW';
    static SAVE_DRAFT: string = 'SAVE_DRAFT';
    static TRACKING: string = 'TRACKING';
    static DIRECT_ERP: string = 'DIRECT_ERP';
    static REMOVE_DIRECT_ERP: string = 'REMOVE_DIRECT_ERP';
    static NEXT_INTERVIEW: string = 'NEXT_INTERVIEW';
    static NEXT_TASK: string = 'NEXT_TASK';
    static MORE_INFORMATION: string = 'MORE_INFORMATION';
    static PRINT_INTERVIEWS: string = 'PRINT_INTERVIEWS';
    static CLOSE_INTERVIEW_CONFIRM: string = 'CLOSE'; //'CLOSE_INTERVIEW_CONFIRM';
    static FAIL_INTERVIEW_CONFIRM: string = 'FAIL_INTERVIEW_CONFIRM';
    static SCAN_CANDIDATE: string = 'SCAN_CANDIDATE';
    static TRANSFER_CNB: string = 'TRANSFER_CNB';
    static UPDATE_TRANSFER_CNB: string = 'UPDATE_TRANSFER_CNB';
    static SEND_EMAIL_OFFER: string = 'SEND_EMAIL_OFFER';
    static UPDATE_OFFER: string = 'UPDATE_OFFER';
    static CANCEL_CANDIDATE: string = 'CANCEL_CANDIDATE';
    static PRINT_OFFER: string = 'PRINT_OFFER';
    static CLOSE_CANDIDATE: string = 'CLOSE';
    static REOPEN_CANDIDATE: string = 'REOPEN_CANDIDATE';
    static REOPEN_CANDIDATE_NOT_START: string = 'REOPEN_CANDIDATE_NOT_START';
    static RR_SCREENING_ASSESSMENT: string = 'RR_SCREENING_ASSESSMENT';
    static RESEND_WAITING_CANDIDATE_ACCEPTANCE: string = 'RESEND_WAITING_CANDIDATE_ACCEPTANCE';
}

export class ACTION_CODE_ONLINE_CANDIDATE {
    static ONLINE_CANDIDATE_APPROVE_AI: string = 'ONLINE_CANDIDATE_APPROVE_AI';
    static ONLINE_CANDIDATE_APPROVE: string = 'ONLINE_CANDIDATE_APPROVE';
    static ONLINE_CANDIDATE_REJECT: string = 'ONLINE_CANDIDATE_REJECT';
}

export class REQUEST_CANDIDATE_TASK_KEY {
    static CLOSE: string = 'CLOSE';
    static FAIL: string = 'FAIL';
    static MATCHING: string = 'MATCHING';
    static WAITING_RR_SCREENING: string = 'WAITING_RR_SCREENING';
    static WAITING_FOR_CV_SENDING: string = 'WAITING_FOR_CV_SENDING';
    static WAITING_CV_SELECTING: string = 'WAITING_CV_SELECTING';
    static WAITING_FOR_INTERVIEW_SETTING: string = 'WAITING_FOR_INTERVIEW_SETTING';
    static WAITING_INTERVIEW: string = 'WAITING_INTERVIEW';
    static WAITING_SUMMARIZE_INTERVIEW: string = 'WAITING_SUMMARIZE_INTERVIEW';
    static WAITING_OFFER: string = 'WAITING_OFFER';
    static WAITING_FAIL_SUMMARIZE_INTERVIEW: string = 'WAITING_FAIL_SUMMARIZE_INTERVIEW';
    static WAITING_CANDIDATE_ACCEPTANCE: string = 'WAITING_CANDIDATE_ACCEPTANCE';
    static REJECT_OFFER: string = 'REJECT_OFFER';
    static PROCESS_OFFER: string = 'PROCESS_OFFER';
}

export class REQUEST_CANDIDATE_STATUS {
    static MATCHING: string = 'MATCHING';
    static RR_SCREENING: string = 'RR_SCREENING'; // RR Assessment (WAITING_RR_SCREENING) + Send to manager confirm (WAITING_FOR_CV_SENDING)
    static CV_SELECTING: string = 'CV_SELECTING'; // Manager Pass Fail (WAITING_CV_SELECTING) + Booking interview (WAITING_FOR_INTERVIEW_SETTING)
    static INTERVIEW: string = 'INTERVIEW'; // Interview (WAITING_INTERVIEW) + Summarize Send offer Next interview (WAITING_SUMMARIZE_INTERVIEW)
    static WAITING_OFFER: string = 'WAITING_OFFER';
    static WAITING_CANDIDATE_ACCEPTANCE: string = 'WAITING_CANDIDATE_ACCEPTANCE';
    static OFFER: string = 'OFFER';
    static DONE: string = 'DONE';
    static CLOSE: string = 'CLOSE';
    static FAIL: string = 'FAIL';
    static CANCEL: string = 'CANCEL';
    static CANCEL_ONBOARDING: string = 'CANCEL_ONBOARDING';
}

export class REQUEST_STATUS {
    static DRAFT: string = 'DRAFT';
    static WAITING_DEPT: string = 'WAITING_DEPT';
    static WAITING_HRBP: string = 'WAITING_HRBP';
    static WAITING_RRM: string = 'WAITING_RRM';
    static INPROCESS: string = 'INPROCESS';
    static DONE: string = 'DONE';
    static CLOSE: string = 'CLOSE';
    static CANCEL: string = 'CANCEL';
    // Status joined
    static REJECTED: string = 'REJECTED';
    static WAITING_APPROVE: string = 'WAITING_APPROVE';
    static WAITING_ASSESS: string = 'WAITING_ASSESS';
    static WAITING_REVIEW: string = 'WAITING_REVIEW';
}

export class ONLINE_CANDIDATE_STATUS {
    static APPROVE: string = 'APPROVE';
    static REJECT: string = 'REJECT';
    static DRAFT: string = 'DRAFT';
}

export class ONLINE_CANDIDATE_RESUME_STATUS {
    static APPROVE: string = 'APPROVE';
    static REJECT: string = 'REJECT';
    static DRAFT: string = 'DRAFT';
    static CANCEL: string = 'CANCEL';
}

export class CANDIDATE_STATUS {
    static OPENING: string = 'OPENING';
    static PROCESSING: string = 'PROCESSING';
    static OFFERED: string = 'OFFERED';
    static EMPLOYEE: string = 'EMPLOYEE';
    static BLACKLIST: string = 'BLACKLIST';
}

export class INTERVIEW_STATUS {
    static BOOKING: string = 'BOOKING';
    static PASS: string = 'PASS';
    static FAIL: string = 'FAIL';
}

export class REQUISITION_CANDIDATE_DISPLAY_STATUS {
    static OFFER_DRAFTING: string = 'Offer Drafting';
}

export class REQUISITION_CANDIDATE_TASK_STATUS {
    static PROCESSING: string = 'PROCESSING';
    static INIT: string = 'INIT';
}

export class REQUISITION_CANDIDATE_OFFER_STATUS {
    static WAITING_SCAN_CANDIDATE: string = 'WAITING_SCAN_CANDIDATE';
    static WAITING_TRANSFERS_CNB: string = 'WAITING_TRANSFERS_CNB';
    static WAITING_ONBOARD: string = 'WAITING_ONBOARD';
    static ISIGN_OPEN: string = 'ISIGN_OPEN';
    static ISIGN_WAITING_SIGN: string = 'ISIGN_WAITING_SIGN';
    static ISIGN_SIGNED: string = 'ISIGN_SIGNED';
    static ISIGN_DECLINED: string = 'ISIGN_DECLINED';
    static ISIGN_CANCEL: string = 'ISIGN_CANCEL';
    static ISIGN_FAILED: string = 'ISIGN_FAILED';
}

export class REQUISITION_CANDIDATE_TASK_DEF_KEY {
    static taskResultHiringManger: string = 'taskResultHiringManger';
    static taskSubResultInterview: string = 'taskSubResultInterview';
}

export class REQUEST_TYPE_CODE {
    static FRESHER: string = 'FRESHER';
    static OFFICIAL: string = 'OFFICIAL';
    static VIRTUAL: string = 'VIRTUAL';
    static COLLABORATOR: string = 'COLLABORATOR';
}

export class HISTORY_ACT_LOG {
    static ETL_HRM_RESOURCE_REQUEST: string = 'ETL_HRM_RESOURCE_REQUEST';
    static HRM_RESOURCE_REQUEST: string = 'HRM_RESOURCE_REQUEST';
    static HRM_RECRUIT_CANDIDATE: string = 'HRM_RECRUIT_CANDIDATE';
}

export class STAKE_HOLDER {
    static RECRUITER: string = 'RECRUITER'; // RR
    static RECRUITERBU: string = 'RECRUITERBU'; // RRBU
    static RRM: string = 'RRM'; // RRM
    static RRBU: string = 'RRBU'; // RRMBU
}

export class CAREER_PATH {
    static PERSONAL_LEVEL: number = 1;
    static CAREER_PATH: number = 0;
}

export class REASON_TYPE_CODE {
    static REJECT_PROCESS_REQUEST: string = 'REJECT_PROCESS_REQUEST';
    static CLOSE_PROCESS_REQUEST: string = 'CLOSE_PROCESS_REQUEST';
    static CANCEL_PROCESS_REQUEST: string = 'CANCEL_PROCESS_REQUEST';
    static FAIL_PROCESS_MATCHING_CANDIDATE: string = 'FAIL_PROCESS_MATCHING_CANDIDATE';
    static CLOSE_PROCESS_MATCHING_CANDIDATE: string = 'CLOSE_PROCESS_MATCHING_CANDIDATE';
    static CANCEL_PROCESS_MATCHING_CANDIDATE: string = 'CANCEL_PROCESS_MATCHING_CANDIDATE';
    static REOPEN_PROCESS_MATCHING_CANDIDATE: string = 'REOPEN_PROCESS_MATCHING_CANDIDATE';
    static CANCEL_SEND_SURVEY: string = 'CANCEL_SEND_SURVEY';
    static PENDING_PROCESS_REQUEST: string = 'PENDING_PROCESS_REQUEST';
    static REOPEN_PROCESS_REQUEST: string = 'REOPEN_PROCESS_REQUEST';
}

export class REQUISITION_STATUS {
    static CANCEL: string = 'CANCEL';
    static CLOSE: string = 'CLOSE';
    static DONE: string = 'DONE';
    static INPROCESS: string = 'INPROCESS';
}

export class GOAL_CATEGORY {
    static DEPARTMENTAL: string = 'DEPARTMENTAL';
    static EMPLOYEE: string = 'EMPLOYEE';
}

export class GOAL_TYPE {
    static POOLED: string = 'POOLED';
    static SHARED: string = 'SHARED';
}

export class ASSIGNMENT {
    static MAIN: any = 1;
}

export const FULL_WAITING_ONBOARD = [
    {
        id: 1,
        label: 'Yes'
    },
    {
        id: 0,
        label: 'No'
    }
]

export const KPI_STATUS = [
    {
        id: 'ON_TARGET',
        label: 'Yes'
    },
    {
        id: 'OFF_TARGET',
        label: 'No'
    }
]

export const FILTER_STATUS = [
    {
        id: 'DRAFT',
        label: 'GENERAL.STATUS.DRAFT'
    },
    {
        id: 'APPROVE',
        label: 'GENERAL.STATUS.APPROVE'
    },
    {
        id: 'REJECT',
        label: 'GENERAL.STATUS.REJECT'
    },
    {
        id: 'CANCEL',
        label: 'GENERAL.STATUS.CANCEL'
    }
]

export const REQUEST_STATUSES = [
    {
        id: 'DRAFT',
        label: 'RECRUITMENT.STATUS.DRAFT'
    },
    {
        id: 'WAITING_HRBP',
        label: 'RECRUITMENT.STATUS.WAITING_HRBP'
    },
    {
        id: 'WAITING_DEPT',
        label: 'RECRUITMENT.STATUS.WAITING_DEPT'
    },
    {
        id: 'WAITING_RRM',
        label: 'RECRUITMENT.STATUS.WAITING_RRM'
    },
    {
        id: 'INPROCESS',
        label: 'RECRUITMENT.STATUS.INPROCESS'
    },
    {
        id: 'DONE',
        label: 'RECRUITMENT.STATUS.DONE'
    },
    {
        id: 'CLOSE',
        label: 'RECRUITMENT.STATUS.CLOSE'
    },
    {
        id: 'CANCEL',
        label: 'RECRUITMENT.STATUS.CANCEL'
    },
    {
        id: 'REJECTED',
        label: 'RECRUITMENT.STATUS.REJECTED'
    }
]

export const REQUEST_STATUSES_TASK = [
    {
        id: 'WAITING_APPROVE',
        label: 'RECRUITMENT.STATUS.WAITING_APPROVE'
    },
    {
        id: 'WAITING_ASSESS',
        label: 'RECRUITMENT.STATUS.WAITING_ASSESS'
    },
    {
        id: 'WAITING_REVIEW',
        label: 'RECRUITMENT.STATUS.WAITING_REVIEW'
    },
    {
        id: 'DRAFT',
        label: 'RECRUITMENT.STATUS.DRAFT'
    },
    {
        id: 'WAITING_HRBP',
        label: 'RECRUITMENT.STATUS.WAITING_HRBP'
    },
    {
        id: 'WAITING_DEPT',
        label: 'RECRUITMENT.STATUS.WAITING_DEPT'
    },
    {
        id: 'WAITING_RRM',
        label: 'RECRUITMENT.STATUS.WAITING_RRM'
    },
    {
        id: 'INPROCESS',
        label: 'RECRUITMENT.STATUS.INPROCESS'
    },
    {
        id: 'DONE',
        label: 'RECRUITMENT.STATUS.DONE'
    },
    {
        id: 'CLOSE',
        label: 'RECRUITMENT.STATUS.CLOSE'
    },
    {
        id: 'CANCEL',
        label: 'RECRUITMENT.STATUS.CANCEL'
    }
]

export const URGENCY_LEVEL = [
    {
        id: 'LEVEL_1',
        label: "WORKFLOW.EDITED.FIELD.URGENCY.LEVEL_1"
    },
    {
        id: 'LEVEL_2',
        label: "WORKFLOW.EDITED.FIELD.URGENCY.LEVEL_2"
    },
    {
        id: 'LEVEL_3',
        label: "WORKFLOW.EDITED.FIELD.URGENCY.LEVEL_3"
    },
]

export const REQUEST_TYPES = [
    {
        id: REQUEST_TYPE_CODE.COLLABORATOR,
        label: 'RECRUITMENT.LABEL.REQUEST_TYPE.COLLABORATOR'
    },
    {
        id: REQUEST_TYPE_CODE.FRESHER,
        label: 'RECRUITMENT.LABEL.REQUEST_TYPE.FRESHER'
    },
    {
        id: REQUEST_TYPE_CODE.OFFICIAL,
        label: 'RECRUITMENT.LABEL.REQUEST_TYPE.OFFICIAL'
    },
    {
        id: REQUEST_TYPE_CODE.VIRTUAL,
        label: 'RECRUITMENT.LABEL.REQUEST_TYPE.VIRTUAL'
    }
]

export const FILTER_CONTROLS_RR: XAdvancedFilterControl[] = [
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'code',
        label: 'WORKFLOW.TASK.LABEL.BUSINESS_KEY'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'aggStatus',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.STAGE'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'requestType',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.REQUEST_TYPE'
    },
    // {
    //     value: '',
    //     type: ControlType.Input,
    //     required: true,
    //     fieldName: 'departmentCode',
    //     label: 'WORKFLOW.TASK.LABEL.DEPARTMENT_CODE'
    // },
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'requester',
        label: 'WORKFLOW.TASK.LABEL.REQUESTER'
    },
    {
        value: '',
        type: ControlType.AutoComplete,
        required: true,
        fieldName: 'jobTitleId',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.JOB_TITLE'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'personalLevelId',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.LEVEL'
    },
    {
        value: '',
        type: ControlType.DateTime,
        required: true,
        fieldName: 'rrmApprove',
        label: 'WORKFLOW.TASK.LABEL.RRM_APPROVE'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'urgency',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.URGENCY'
    },
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'reportToData',
        label: 'WORKFLOW.TASK.LABEL.REPORT_TO'
    },
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'handleBy',
        label: 'WORKFLOW.TASK.LABEL.HANDLE_BY'
    },
    {
        value: '',
        type: ControlType.AutoComplete,
        required: true,
        fieldName: 'placeId',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.PLACE'
    }
]

export const FILTER_CONTROLS: XAdvancedFilterControl[] = [
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'code',
        label: 'WORKFLOW.TASK.LABEL.BUSINESS_KEY'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'aggStatus',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.STAGE'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'requestType',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.REQUEST_TYPE'
    },
    {
        value: '',
        type: ControlType.AutoComplete,
        required: true,
        fieldName: 'jobTitleId',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.JOB_TITLE'
    },
    {
        value: '',
        type: ControlType.Select,
        required: true,
        fieldName: 'personalLevelId',
        isMultiple: true,
        label: 'WORKFLOW.TASK.LABEL.LEVEL'
    },
    {
        value: '',
        type: ControlType.Input,
        required: true,
        fieldName: 'reportToData',
        label: 'WORKFLOW.TASK.LABEL.REPORT_TO'
    }
]

export const GROUP_CONTROLS_RR: XAdvancedGroupControl[] = [
    {
        fieldName: 'aggStatus',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.STAGE',
    },
    {
        fieldName: 'requestType',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.REQUEST_TYPE',
    },
    // {
    //     fieldName: 'departmentCode',
    //     active: false,
    //     label: 'WORKFLOW.TASK.LABEL.DEPARTMENT_CODE',
    // },
    {
        fieldName: 'jobTitle',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.JOB_TITLE',
    },
    {
        fieldName: 'personalLevel',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.LEVEL',
    },
    {
        fieldName: 'handleBy',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.HANDLE_BY',
    }
]

export const GROUP_CONTROLS: XAdvancedGroupControl[] = [
    {
        fieldName: 'aggStatus',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.STAGE',
    },
    {
        fieldName: 'requestType',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.REQUEST_TYPE',
    },
    {
        fieldName: 'jobTitle',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.JOB_TITLE',
    },
    {
        fieldName: 'personalLevel',
        active: false,
        label: 'WORKFLOW.TASK.LABEL.LEVEL',
    }
]

export class PROBATION_TYPE {
    static OFFER_LETTER: any[] = ['OFFER_LETTER'];
    static DEFINITE_LABOR: any[] = ['DEFINITE_LABOR_01', 'DEFINITE_LABOR_02', 'DEFINITE_LABOR_03'];
    static INDEFINITE_LABOR: any[] = ['INDEFINITE_LABOR'];
    static CONSULTING: any[] = ['CONSULTING_06'];
    static TEMPORARY_CONTRACT: any[] = ['TEMPORARY_CONTRACT_01', 'TEMPORARY_CONTRACT_02', 'TEMPORARY_CONTRACT_03', 'TEMPORARY_CONTRACT_04', 'TEMPORARY_CONTRACT_05', 'TEMPORARY_CONTRACT_06', 'TEMPORARY_CONTRACT_09', 'TEMPORARY_CONTRACT_11', 'TEMPORARY_CONTRACT_12'];
    static TEMP_DEFINITE: any[] = ['TEMP_DEFINITE_01', 'TEMP_DEFINITE_02', 'TEMP_DEFINITE_03'];
    static TEMP_INDEFINITE: any[] = ['TEMP_INDEFINITE_LESS_01', 'TEMP_INDEFINITE_00'];
    static SERVICE: any[] = ['SERVICE_01', 'SERVICE_02', 'SERVICE_03', 'SERVICE_06', 'SERVICE_12'];
    static FRESHER: any[] = ['FRESHER_03'];
    static INTERNSHIP: any[] = ['INTERNSHIP_03'];
}

export class WORKER_TYPE {
    static PERMANENT: any = 'PERMANENT';
    static FREELANCER: any = 'FREELANCER';
    static INTERN: any = 'INTERN';
    static FRESHER: any = 'FRESHER';
    static CONTRACTOR: any = 'CONTRACTOR';
}

export class MARKET_TYPE {
    static VIETNAM: any[] = ['VN', 'VNI', 'VNM'];
    static CHINA: any[] = ['CN', 'CHN'];
}

export class INTERVIEW_TYPE {
    static ONLINE: any[] = ['ONL', 'ONLINE'];
    static OFFLINE: any[] = ['OFF', 'OFFLINE'];
}

export class INTERVIEW_CHANNEL {
    static TEAMS: any = 'TEAMS';
    static ZOOM: any = 'ZOOM';
}

export class INTERVIEWER_ROLE {
    static FuncInterview: any = 'FuncInterview';
    static RRInCharge: any = 'RRInCharge';
    static DeptHead: any = 'DeptHead';
    static HRBP: any = 'HRBP';
}

export class INTERVIEWER_RESULT {
    static PASS: any = 'Pass';
    static FAIL: any = 'Fail';
    static NONE: any = 'None';
}

export class MEETING_ROOM_STATUS {
    static Unknown: any = 'Unknown';
    static Free: any = 'Free';
    static Tentative: any = 'Tentative';
    static Busy: any = 'Busy';
    static Oof: any = 'Oof';
    static WorkingElsewhere: any = 'WorkingElsewhere';
}

export class APPROVAL_RESULT {
    static PASS: any = 'PASS';
    static FAIL: any = 'FAIL';
    static CLOSED: any = 'CLOSED';
    static CANCELED: any = 'CANCELED';
    static UPDATE_OFFER: any = 'UPDATE_OFFER';
    static CANCEL: any = 'CANCEL';
    static NEXT_INTERVIEW: any = 'NEXT_INTERVIEW';
    static NEXT_TASK: any = 'NEXT_TASK';
    static CLOSE: any = 'CLOSE';
    static COMPLETE: any = 'COMPLETE';
    static SEND_TO_INTERVIEW: any = 'SEND_TO_INTERVIEW';
    static SEND_TO_CONFIRM: any = 'SEND_TO_CONFIRM';
    static REOPEN: any = 'REOPEN';
    static SEND_TO_OFFER: any = 'SEND_TO_OFFER';
    static CREATE_OFFER: any = 'CREATE_OFFER';
    static ACCEPT_OFFER: any = 'ACCEPT_OFFER';
    static REJECT_OFFER: any = 'REJECT_OFFER';
    static RESEND_OFFER: any = 'RESEND_OFFER';
    static ACCEPT_OFFER_CHANGE_EMP_TYPE: any = 'ACCEPT_OFFER_CHANGE_EMP_TYPE';
    static UPDATE_IDENTITY: any = 'UPDATE_IDENTITY';
    static RESEND_WAITING_CANDIDATE_ACCEPTANCE: any = 'RESEND_WAITING_CANDIDATE_ACCEPTANCE';
}

export class FLOW_TYPE {
    static FLOW_1: any = 'FLOW_1'; // Support Change Employee Type
    static FLOW_2: any = 'FLOW_2'; // Official
    static FLOW_3: any = 'FLOW_3'; // Staff Movement
    static INTERNAL_SOURCE: any = 'INTERNAL_SOURCE';
    static INTERNAL_SOURCE_SUPPORT: any = 'INTERNAL_SOURCE_SUPPORT';
    static HIRED: any = 'HIRED';
    /*
    INTERNAL_SOURCE: hc.status in ('EMPLOYEE', 'PROCESSING') and (hc.staff_movement_flg = 1 OR hc.change_emp_type_flg = 1)
    INTERNAL_SOURCE_SUPPORT: hc.status = 'OPENING' 
                            OR (hc.status = 'PROCESSING' and hc.staff_movement_flg = 0 and hc.change_emp_type_flg = 0) 
                            OR (hc.status in ('EMPLOYEE', 'PROCESSING') and hc.change_emp_type_flg = 1)
    HIRED: hc.status = 'OPENING' 
            OR (hc.status = 'PROCESSING' and hc.staff_movement_flg = 0 and hc.change_emp_type_flg = 0) 
            OR (hc.status in ('EMPLOYEE', 'PROCESSING') and staff_movement_flg = 1)
    */
}

export class NEXT_TASK {
    static WAITING_RR_SCREENING: any = 'WAITING_RR_SCREENING';
    static WAITING_FOR_CV_SENDING: any = 'WAITING_FOR_CV_SENDING';
    static WAITING_FOR_INTERVIEW_SETTING: any = 'WAITING_FOR_INTERVIEW_SETTING';
    static WAITING_OFFER: any = 'WAITING_OFFER';
}

export class LOCALITY {
    static CITY: any[] = ['LOCALITY-1', 'CITY'];
    static DISTRICT: any[] = ['LOCALITY-2', 'DISTRICT'];
    static WARD: any[] = ['LOCALITY-3', 'WARD'];
}

export class SKILL_CATEGORY {
    static CATEGORY: any = 'CATEGORY';
    static SUB_CATEGORY: any = 'SUB_CATEGORY';
    static SKILL: any = 'SKILL';
}

export class SOURCE_TYPE {
    static SOURCE_CATEGORY: any = 'TYPE'; // SOURCE CATEGORY
    static SOURCE_TYPE: any = 'SOURCE_TYPE'; // SOURCE TYPE
    static SOURCE: any = 'SOURCE'; // SOURCE
}

export class JOB_TYPE {
    static FREELANCE: any = 'FREELANCE';
    static FULLTIME: any = 'FULLTIME';
}

export class CLASSIFICATION {
    static TRACKGROUP: any = 'TRACKGROUP';
    static TRACK: any = 'TRACK';
    static FAMILY: any = 'FAMILY';
    static GROUP: any = 'GROUP';
    static SUBGROUP: any = 'SUBGROUP';
    static JOB: any = 'JOB';
    static CATEGORY: any = 'CATEGORY';
}

export class UNIT_TYPE {
    static DEPT: any = 'DEPT';
    static COGRP: any = 'COGRP';
    static CO: any = 'CO'
}

export class UNIT_CLASS {
    static DEPT: any = 'DEPT';
    static TEAM: any = 'TEAM';
}

export class EXCLUSION_TYPE {
    static EXCLUSION_7: any = 'EXCLUSION_7'; // Employee
    static EXCLUSION_8: any = 'EXCLUSION_8'; // Department (Team)
}

export class QUALIFICATION_TYPE {
    static CER: any = 'CER';
    static DEG: any = 'DEG';
    static EDU: any = 'EDU';
}

export class COUNTRY {
    static VIETNAM: any = 'VN';
}

export class NATIONALITY {
    static VIETNAM: any = 'VN';
}